import VanillaMask from "vanilla-masker";

export default serviceorder => {
  return {
    id: serviceorder.id,
    hirer: {
      label: serviceorder.hirer.fantasyName,
      value: serviceorder.hirer.id
    },
    customer: {
      label: serviceorder.customer.name,
      value: serviceorder.customer.id
    },
    address: {
      label: serviceorder.address.street
        ? serviceorder.address.street.includes("-")
          ? serviceorder.address.street.replace(
              "-",
              `- ${serviceorder.address.number}, `
            )
          : serviceorder.address.street +
            " - " +
            serviceorder.address.number +
            ", " +
            serviceorder.address.city +
            " - " +
            serviceorder.address.state
        : serviceorder.address.position.latitude +
          "  " +
          serviceorder.address.position.longitude,
      value: serviceorder.address.id
    },
    contact: {
      label: serviceorder.contact.name,
      value: serviceorder.contact.id
    },
    executionDate: serviceorder.executionDate,
    concludedDate: serviceorder.concludedDate,
    startedDate: serviceorder.startedDate,
    conclusionNotes: serviceorder.conclusionNotes,
    service: {
      label: serviceorder.service.name,
      value: serviceorder.service.id
    },
    totalService:
      serviceorder.price +
      serviceorder.material.price +
      serviceorder.refund.price,
    price: serviceorder.price ? serviceorder.price * 100 : 0,

    valueMaterial: serviceorder.material.price * 100,
    valueRefund: serviceorder.refund.price
      ? serviceorder.refund.price * 100
      : 0,
    netPrice: serviceorder.netPrice,
    tranpoCommission: serviceorder.tranpoCommission,
    status: serviceorder.status,
    technician: serviceorder.technician
      ? {
          email: serviceorder.technician ? serviceorder.technician.email : "",
          id: serviceorder.technician ? serviceorder.technician.id : "",
          name: serviceorder.technician ? serviceorder.technician.name : ""
        }
      : null,
    provider: serviceorder.provider
      ? {
          id: serviceorder.provider ? serviceorder.provider.id : "",
          fantasyName: serviceorder.provider
            ? serviceorder.provider.fantasyName
            : ""
        }
      : null,
    description: serviceorder.description,
    pendingReason: serviceorder.reasonForPending,
    protocol: serviceorder.protocol,
    artifacts: serviceorder.artifacts,
    attachments: serviceorder.attachments,
    commissionPercentage:
      serviceorder.commissionPercentage > 0
        ? Number(serviceorder.commissionPercentage)
        : 0.15,
    answer: serviceorder.answer,
    signature: serviceorder.signature,
    formName: serviceorder.formName,
    externalId: serviceorder.externalId,
    isToFindProviders: serviceorder.isToFindProviders,
    material: {
      price: serviceorder.material.price,
      percentage: serviceorder.material.percentage
    },
    refund: {
      price: serviceorder.refund.price,
      percentage: serviceorder.refund.percentage
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/service-order/OrderServiceBuildFormObject.js